// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 869 ? "devtools" : chunkId) + "." + {"767":"08028a46","869":"67300be2"}[chunkId] + ".chunk.js";
};